import React, { useState } from "react";
import { Modal, Button, Form, Row, Col, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import axios from "axios";
import { Box } from "@mui/system";
import { Slider, TextField, Typography } from "@mui/material";

const HOURS = 24;

const SaveClipModal = () => {
  const [highQuality, setHighQuality] = useState(true);
  const [name, setName] = useState("Chef Cap Detection");
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [videoURLs, setVideoURLs] = useState([]);

  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
  const [range, setRange] = useState([2, 4]); // default 2h → 4h

  const { modalType = "", data } = useSelector((state) => state?.PopupReducer?.modal || {});

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "",
        showModal: false,
        data: null,
      })
    );
  };

  const createVideo = async () => {
    if (modalType !== "SAVECLIP" || !data) return;

    try {
      setLoading(true);
      const payload = {
        camera_id: data?.camera_id,
        start_date: data?.startTime,
        end_date: data?.endTime,
      };
      const response = await axios.post(
        "https://visionemptrack.greymatterz.com/streaming/export-clip",
        payload
      );

      setVideoURLs((prev) => [...prev, response?.data?.data?.file]);
    } catch (err) {
      console.log("[ERROR] error Creating Clips: ", err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event, newValue) => {
    let [start, end] = newValue;

    // enforce min 1h and max 8h range
    if (end - start < 1) {
      end = start + 1;
    }
    if (end - start > 8) {
      end = start + 8;
    }
    setRange([start, end]);
  };

  return (
    <Modal show={true} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton style={{ backgroundColor: "#E6E3FF" }}>
        <Modal.Title className="text-dark">Save | Download Clips</Modal.Title>
        <div className="ms-auto d-flex align-items-center px-2">
          <span className="badge bg-light text-dark">
            <i className="bi bi-shop me-1"></i> Location: <strong>Cash Counter</strong>
          </span>
        </div>
      </Modal.Header>

      <Modal.Body>
        <Row className="mb-3">
          <Col>
            <Form.Group>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter clip name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Add notes"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="mb-3">
          <Form.Label>Video Quality</Form.Label>
          <Form.Check
            type="switch"
            id="quality-switch"
            label="High Quality"
            checked={highQuality}
            onChange={() => setHighQuality(!highQuality)}
          />
        </div>

        <Row className="mb-3">
          <Col md={3}>
            <Card>
              <Card.Img
                variant="top"
                src={`https://visionemptrack.greymatterz.com/attendance_photos/camera_thumbnail/${data?.camera_id}.png`}
              />
              <Card.Body className="p-2">
                <Card.Text className="small text-center">Camera View</Card.Text>
              </Card.Body>
            </Card>
          </Col>

          {videoURLs.map((url, index) => (
            <Col md={3}>
              <Card>
                <video
                  src={"https://visionemptrack.greymatterz.com/streaming/clips/" + url}
                  controls
                />
                <Card.Body className="p-2">
                  <Card.Text className="small text-center">clip {index + 1}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}

          {/* <Col md={3}>
            <div
              className="d-flex justify-content-center align-items-center border"
              style={{
                height: "100px",
                backgroundColor: "#f8f9fa",
                cursor: "pointer",
              }}
            >
              <span className="fs-2">+</span>
            </div>
          </Col> */}
        </Row>

        <div className="mb-2">
          <small className="text-muted">
            Select a minimum of 1 minute up to 24 hours of video*
          </small>
        </div>

        {/* Mock Timeline */}
        {/* <div
          className="position-relative p-3"
          style={{ background: "#f1edfc", borderRadius: "8px" }}
        >
          <div className="progress" style={{ height: "20px" }}>
            <div
              className="progress-bar bg-primary"
              role="progressbar"
              style={{ width: "30%" }}
            ></div>
          </div>
          <div
            style={{
              position: "absolute",
              top: "10px",
              left: "25%",
              width: "2px",
              height: "30px",
              background: "red",
            }}
          ></div>
          <div className="d-flex justify-content-between mt-2">
            <small>00:00</small>
            <small>04:00</small>
            <small>08:00</small>
            <small>12:00</small>
          </div>
        </div> */}

        <Box
          sx={{
            p: 3,
            backgroundColor: "#f1edfc",
            borderRadius: 2,
          }}
        >
          {/* Date Picker */}
          <Box mb={2}>
            <Typography variant="body1" gutterBottom>
              Select Date
            </Typography>
            <TextField
              type="date"
              size="small"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
            />
          </Box>

          {/* Range Slider */}
          <Box mb={2}>
            <Typography variant="body1" gutterBottom>
              Selected Range: {String(range[0]).padStart(2, "0")}:00 –{" "}
              {String(range[1]).padStart(2, "0")}:00
            </Typography>

            <Slider
              value={range}
              min={0}
              max={HOURS}
              step={1}
              onChange={handleChange}
              valueLabelDisplay="on"
              marks={[
                { value: 0, label: "00:00" },
                { value: 6, label: "06:00" },
                { value: 12, label: "12:00" },
                { value: 18, label: "18:00" },
                { value: 24, label: "24:00" },
              ]}
              sx={{
                color: "#1976d2",
                height: 6,
                "& .MuiSlider-thumb": {
                  height: 20,
                  width: 20,
                  backgroundColor: "#fff",
                  border: "2px solid currentColor",
                },
                "& .MuiSlider-valueLabel": {
                  background: "#1976d2",
                  color: "#fff",
                  borderRadius: "4px",
                },
              }}
            />
          </Box>
        </Box>

        <div className="text-center my-2">
          <Button variant="primary" onClick={createVideo}>
            {loading ? (
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            ) : (
              "Extract Clip"
            )}
          </Button>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary">Save Clip</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveClipModal;
